import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { NzCarouselModule } from 'ng-zorro-antd/carousel';
import { NzSkeletonComponent } from 'ng-zorro-antd/skeleton';
import { NzTagModule } from 'ng-zorro-antd/tag';
import { environment } from '../../../environments/environment';
import { GenericService } from '../../services/generic.services';
import { NewsService } from '../../services/news.service';
import { NewsDetailComponent } from './news-old-detail/news-old-detail.component';

@Component({
  selector: 'app-news',
  standalone: true,
  imports: [
    CommonModule,
    RouterLink,
    NzSkeletonComponent,
    NzCarouselModule,
    NzTagModule,
    TranslateModule,
    NewsDetailComponent,
  ],
  templateUrl: './news-old.component.html',
  styleUrl: './news.component.scss',
})
export class NewsOldComponent {
  channel: string = '';

  urlIMG = environment.urlIMG;
  loader = true;
  arraysNotice: Array<any> = [];
  topNews: any = {};

  public moreNews: boolean = true;

  constructor(
    private readonly _activateRoute: ActivatedRoute,
    private readonly newsService: NewsService,
    public readonly genericServices: GenericService
  ) {}

  ngOnInit(): void {
    this._activateRoute.params.subscribe((params: any) => {
      this.channel = params && 'channel' in params ? params.channel : '';
    });

    this.loader = true;
    this.loadAllNews();
    this.loadCrouselNews();
  }

  ngOnChanges(): void {
    this._activateRoute.params.subscribe((params: any) => {
      this.channel = params && 'channel' in params ? params.channel : '';
    });
  }

  loadAllNews(): void {
    this.newsService.getFeedUpdates().subscribe(
      (result: any) => {
        if (result.status) {
          this.arraysNotice = result.data.slice(4);
          setTimeout(() => {
            this.loader = false;
          }, 500);
        } else this.loader = false;
      },
      () => {
        this.loader = false;
      }
    );
  }

  loadCrouselNews(): void {
    this.newsService.getFeedUpdatesCarrousel().subscribe(
      (result: any) => {
        if (result.status) {
          this.topNews = result.data;
          setTimeout(() => {
            this.loader = false;
          }, 500);
        } else this.loader = false;
      },
      () => {
        this.loader = false;
      }
    );
  }

  formatDate(date: string) {
    return date;
    // return moment(date).format('MMMM DD, YYYY');
  }
}
